import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { API_URL } from '../../config';
import ControlledInput from '../../common/ControlledInput/ControlledInput';
import DataWrapper from '../../common/DataWrapper/DataWrapper';
import CheckBox from '../../common/CheckBox/CheckBox';
import Captcha from '../../common/Captcha/Captcha'; 
import BtnConfirm from '../../common/BtnConfirm/BtnConfirm';
import { CONTROLLED_INPUT_INVALID } from '../../globals';
import ControlledTextArea from '../../common/ControlledTextArea/ControlledTextArea';


class ConfirmForm extends Component {
  handleTextAreaChange = (value, name) => {
    const { handleChangeInput, } = this.props;
    
    if (value.length < 501) {
      handleChangeInput(value, name);
    }
  }

  render() {
    const { 
      reservationCommon,
      confirmData,
      handleChangeInput,
      handleOnClickConfirm,
      error,
    } = this.props;
    const {
      name ,email, phone, note, agreement, 
      nameValid, emailValid, noteValid, phoneValid, agreementValid, captchaValid,
    } = this.props.inputs;
    const fileSrc = API_URL + '/files/' + reservationCommon.agreement.document;

    // Error Confirm reservation
    let errorMessage;
    let icon;

    if (!error.blacklist) {
      errorMessage = "Tento e-mail je blokován!";
      icon = 'fa-ban';

    } else if (!error.nonDuplicatedEmail) {
      errorMessage = "Zadaný e-mail již má vytvořenou rezervaci na vybraný čas. Zadejte prosím jiný e-mail!";
      icon = 'fa-envelope-open';

    } else {
      errorMessage = "Něco se nepovedlo. Zkuste prosím stránku načíst znovu, nebo opakujte akci později.";
      icon = 'fa-exclamation-triangle';
    }

    return (
      <div>
        <div className="row">
          <div className="col col col-md-6 col-sm-12">
            <form autoComplete="on" id="contact_form">
              
              { reservationCommon.name.show &&
                <ControlledInput
                  inputState={nameValid}
                  value={name}
                  name="name"
                  handleChange={handleChangeInput}
                  icon="user"
                  placeHolder="Jméno"
                  required={reservationCommon.name.isRequired}
                />
              }
              
              { reservationCommon.phone.show &&
                <ControlledInput
                  inputState={phoneValid}
                  value={phone}
                  name="phone"
                  handleChange={handleChangeInput}
                  icon="phone"
                  placeHolder="Telefon"
                  required={reservationCommon.phone.isRequired}
                />
              }

              <ControlledInput
                inputState={emailValid}
                value={email}
                name="email"
                handleChange={handleChangeInput}
                icon="envelope"
                placeHolder="E-mail"
                required
              />

              { reservationCommon.note.show &&
                <ControlledTextArea 
                  inputState={noteValid}
                  value={note}
                  name="note"
                  onChange={this.handleTextAreaChange}
                  placeholder="Poznámka"
                />
              }

            </form>        
          </div>
        </div>
        
        { reservationCommon.agreement.show &&
          <CheckBox
            name="agreement"
            value={agreement}
            inputState={agreementValid}
            onChange={handleChangeInput}
            required
          >
            {<span>
              {reservationCommon.agreement.text + ' '}
              { (reservationCommon.agreement.document !== undefined && reservationCommon.agreement.document !== null) &&
                <a href={fileSrc} target="_blank">Podmínky naleznete zde</a>
              }
            </span>}
          </CheckBox>
        }
        
        <Captcha
          name="captcha"
          handleChange={handleChangeInput}
          validation={captchaValid}
        />

        {confirmData.error && (
          <div className="row">
            <div className="col col col-md-6 col-sm-12">
              <table className="reservation-form--error-table">
                <tbody>
                  <tr>
                    <td className="reservation-form--error-icon">
                      <i className={'fa ' + icon} aria-hidden="true"></i>
                    </td>
                    <td className="reservation-form--error-text">
                      <p>{ errorMessage }</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        
        <div className="row">
          <div className="col col col-md-6 col-sm-12">

            <DataWrapper
              isLoading={confirmData.isLoading}
              isLoadingText="Vyčkejte prosím"
              status={true}
              minHeight={60}
            >
              <BtnConfirm
                title="POTVRDIT"
                handleOnCLick={handleOnClickConfirm}
                isEnabled={ !(
                  nameValid === CONTROLLED_INPUT_INVALID 
                  || emailValid === CONTROLLED_INPUT_INVALID 
                  || phoneValid === CONTROLLED_INPUT_INVALID 
                  || agreementValid === CONTROLLED_INPUT_INVALID
                  || captchaValid === CONTROLLED_INPUT_INVALID 
                ) }
              />
            </DataWrapper> 
      
          </div>
        </div>

        <div className="row">
          <div className="col col col-md-6 col-sm-12">
            * Povinné položky
          </div>
        </div>
      </div>
    );
  }
}


ConfirmForm.propTypes = {
  inputs: PropTypes.object.isRequired,
  confirmData: PropTypes.object.isRequired,
  handleOnClickConfirm: PropTypes.func.isRequired,
  handleChangeInput: PropTypes.func.isRequired,
};


export default ConfirmForm;



// WEBPACK FOOTER //
// ./src/components/ReservationContent/ConfirmForm.js